export default __webpack_public_path__ + "static/media/ico-connect-wallet.134b882f.svg";